import { render, staticRenderFns } from "./ReelControlOverlay.vue?vue&type=template&id=31945784&scoped=true"
import script from "./ReelControlOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReelControlOverlay.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ReelControlOverlay.vue?vue&type=style&index=0&id=31945784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31945784",
  null
  
)

export default component.exports